import { Stack, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { useAuth } from "@/providers";
import { useCurrentOrgId } from "@/providers/auth/hooks";
import { Comments } from "@/shared/components/comments";
import { useRecentComments } from "@/shared/domain/comments/hooks";
import { useOrgMemberDirectory } from "@/shared/domain/orgs/hooks";

interface RecentCommentsProps {
  count: number;
}

export function RecentComments({ count }: RecentCommentsProps) {
  const theme = useTheme();
  const { currentUser } = useAuth();
  const memberDirectory = useOrgMemberDirectory(useCurrentOrgId());

  const [avatarMap, setAvatarMap] = useState<{ [key: string]: string }>({});

  const { data: comments = [], isLoading } = useRecentComments();

  // Avatars come from the org member directory, keyed by user id.
  useEffect(() => {
    const newAvatarMap: { [key: string]: string } = {};
    memberDirectory.forEach((member, memberId) => {
      newAvatarMap[memberId] = member.picture_url ?? "";
    });

    setAvatarMap(newAvatarMap);
  }, [memberDirectory]);

  // Show only the first 'count' comments
  const displayedComments = comments.slice(0, count);

  if (isLoading) {
    return null;
  }

  return (
    <Stack
      sx={{
        mt: theme.spacing(1.5),
        mb: theme.spacing(3),
      }}
    >
      <Comments.List>
        {displayedComments.map((comment) => {
          const avatarUrl = avatarMap[comment.created_by] ?? "";
          return (
            <Comments.Item
              key={comment.comment_id}
              comment={comment}
              avatarUrl={avatarUrl}
              currentUserId={currentUser?.user_id ?? ""}
              summaryView={true}
            />
          );
        })}
      </Comments.List>
    </Stack>
  );
}
